import { useEffect } from 'react'
import { listAgency, listDriver } from './storage'

export default function useInitial() {
    useEffect(() => {
        Promise.all([listAgency.load(), listDriver.load()])
    }, [])
}
